<template>
    <div class="team-page">
        <div class="top-menu">
            <div class="top">人工智能与机器视觉实验室</div>
            <div class="blank"></div>
            <div class="menu">
                <div class="menu-detail" @click="jumpToHome">首页</div>
                <div class="menu-detail" @click="jumpToTutor">导师风采</div>
                <div class="menu-detail" @click="jumpToTeam">科研团队</div>
                <div class="menu-detail" @click="jumpToPaper">论文成果</div>
                <div class="menu-detail" @click="jumpToHonor">获奖情况</div>
                <div class="menu-detail" @click="jumpToDownload">文件下载</div>
                <div class="menu-detail" style="font-family: 'Times New Roman', Times, serif;" @click="jumpToInnovation"> Innovation </div>
                <div class="menu-detail" style="font-family: 'Times New Roman', Times, serif;" @click="jumpToService"> Service </div>
                <div class="menu-detail" style="font-family: 'Times New Roman', Times, serif;" @click="jumpToInfluence_Contribution"> Influence and Contribution </div>
            </div>
        </div>

        <div class="blank"></div>
        <div class="page-content">
            <div class="paper-block">
                <div class="paper-block-title">Selected Papers</div>
                <div class="paper-block-word">
                    <div class="paper-block-word-item">
                        [1] <b>Tao Lei*</b>, Xiaohong Jia, Yanning Zhang, Lifeng He, Hongying Meng and Asoke K. Nandi, 
                        "Significantly fast and robust fuzzy c-means clustering algorithms based on morphological reconstruction and membership filtering,"
                        <span style="font-weight: bold; font-style: italic;"> IEEE Transactions on Fuzzy Systems </span>, vol. 26, no. 5, pp. 3027-3041, Oct. 2018. (Google scholar citation: 
                        <span style="font-weight: bold; color:blue;">442+</span>)                     
                        </div>
                    <div class="paper-block-word-item">
                        [2] <b>Tao Lei*</b>, Xiaohong Jia, Yanning Zhang, Shigang Liu, Hongying Meng and Asoke K. Nandi, 
                        "Superpixel-based fast fuzzy c-means clustering algorithms for color image segmentation,"
                        <span style="font-weight: bold; font-style: italic;"> IEEE Transactions on Fuzzy Systems </span>, vol. 27, no. 9, pp. 1753-1766, Sept. 2019. (Google scholar citation: 
                        <span style="font-weight: bold; color:blue;">309+</span>)
                        </div>
                    <div class="paper-block-word-item">
                        [3] <b>Tao Lei*</b>, Xiaohong Jia, Tongliang Liu, Shigang Liu, Hongying Meng and Asoke K. Nandi,
                        "Adaptive morphological reconstruction for seeded image segmentation,"
                        <span style="font-weight: bold; font-style: italic;"> IEEE Transactions on Image Processing </span>, vol. 28, no. 11, pp. 5510-5523, Nov. 2019. (Google scholar citation:
                        <span style="font-weight: bold; color:blue;">90+</span>)
                        </div>
                    <div class="paper-block-word-item">
                        [4] <b>Tao Lei*</b>, Peng Liu, Xiaohong Jia, Xuande Zhang, Hongying Meng and Asoke K. Nandi, 
                        "Automatic fuzzy clustering framework for image segmentation,"
                        <span style="font-weight: bold; font-style: italic;">IEEE Transactions on Fuzzy Systems </span>, vol. 28, no. 9, pp. 2078-2092, Sept. 2020. (Google scholar citation:
                        <span style="font-weight: bold; color:blue;">144+</span>)
                        </div>
                    <div class="paper-block-word-item">
                        [5] <b>Tao Lei*</b>, et al., 
                        "Landslide inventory mapping from bi-temporal images using a deep convolution network,"
                        <span style="font-weight: bold; font-style: italic;"> IEEE Transactions on Geoscience and Remote Sensing </span>, vol. 16, no. 6, pp 163-170, Jun. 2019. (Google scholar citation: 
                        <span style="font-weight: bold; color:blue;">208+</span>)
                        </div>
                    <div class="paper-block-word-item">
                        [6] <b>Tao Lei*</b>, et al., 
                        "Difference enhancement and spatial-spectral non-local network for change detection in VHR remote sensing images,"
                        <span style="font-weight: bold; font-style: italic;"> IEEE Transactions on Geoscience and Remote Sensing </span>, vol. 60, pp. 4507013(1-13). doi: 10.1109/TGRS.2021.3134691. (Google scholar citation:
                        <span style="font-weight: bold; color:blue;">57+</span>)
                        </div>
                    <div class="paper-block-word-item">
                        [7] <b>Tao Lei*</b>, et al., 
                        "Triple change detection network via joint multi-frequency and full-scale Swin-Transformer for remote sensing images," 
                        <span style="font-weight: bold; font-style: italic;">IEEE Transactions on Geoscience and Remote Sensing </span>, vol. 61, pp. 4402114(1-14), March, 2023. (Google scholar citation:
                        <span style="font-weight: bold; color:blue;">33+</span>)
                        </div>
                    <div class="paper-block-word-item">
                        [8] Dinghua Xue, <b>Tao Lei*</b>, Peng Liu, Xiaohong Jia, Xuande Zhang, Hongying Meng and Asoke K. Nandi, 
                       "Automatic fuzzy clustering framework for image segmentation,"
                        <span style="font-weight: bold; font-style: italic;">IEEE Transactions on Geoscience and Remote Sensing </span>, vol. 61, pp. 4408415 (1-15), Sept. 2023. (Google scholar citation: 
                        <span style="font-weight: bold; color:blue;">4+</span>)
                        </div>
                    <div class="paper-block-word-item">
                        [9] <b>Tao Lei*</b>,  et al., 
                        "DefED-Net: deformable encoding context network for liver and liver-Tumor segmentation,"
                        <span style="font-weight: bold; font-style: italic;">IEEE Transactions on Radiation and Plasma Medical Sciences </span>, vol. 6, no. 1, pp. 68-78, January 2022. (Google scholar citation:
                        <span style="font-weight: bold; color:blue;">69+</span>)
                        </div>
                    <div class="paper-block-word-item">
                        [10] <b>Tao Lei*</b>, et al., 
                        "Semi-supervised medical image segmentation using adversarial consistency learning and dynamic convolution network,"
                        <span style="font-weight: bold; font-style: italic;">IEEE Transactions on Medical Imaging </span>, vol. 6, no. 1, pp. 68-78, January 2022. (Google scholar citation:
                        <span style="font-weight: bold; color:blue;">37+</span>)
                        </div>
                    <div class="paper-block-word-item">
                        [11] <b>Tao Lei*</b>, et al., 
                        "CiT-Net: convolutional neural networks hand in hand with vision Transformers for medical image segmentation,"The 32nd International Joint Conference on Artificial Intelligence, 
                        <span style="font-weight: bold; font-style: italic;">IJCAI2023 </span>, MACAO, August 19-25, 2023. (Google scholar citation:
                        <span style="font-weight: bold; color:blue;">6+</span>)
                        </div>
                    <div class="paper-block-word-item">
                        [12] Risheng Wang, <b>Tao Lei*</b>, Peng Liu, Xiaohong Jia, Xuande Zhang, Hongying Meng and Asoke K. Nandi, 
                       "Automatic fuzzy clustering framework for image segmentation,"
                        <span style="font-weight: bold; font-style: italic;"> IET Image Processing </span>, 2022, vol. 16, no. 5, pp. 1243-1267. (Google scholar citation:
                        <span style="font-weight: bold; color:blue;">402+</span>)
                        </div>
                    <div class="paper-block-word-item">
                        [13] <b>Tao Lei*</b>, Asoke K. Nandi, Image Segmentation Principles, Techniques, and Applications, Wiley, 2023. 9, ISBN: 9781119859000, John Wiley & Sons, Ltd., West Sussex, PO19 8SQ, UK.
                        </div>
                </div> 
                <span>More publications please see in the link: 
                <a href="https://scholar.google.com.hk/citations?hl=zh-CN&user=nLpRqykAAAAJ" target="_blank" style="user-select: auto;"><span style="font-family: Arial; font-size: 16px; user-select: auto;">[Link]</span></a> </span>               
             </div>
        </div>

             <div class="footer">Copyright© 2019 All Rights Reserved. 陕西科技大学人工智能与机器视觉实验室版权所有  </div>
    </div>
</template>

<script>
    export default {
    data() {
        return {
            path: process.env.BASE_URL,
            CiT_Net: "../download/CiT_Net.pdf",
            Def_Net: "../download/DefED-net.pdf",
            TCDS: "../download/TCDS.pdf",
            USSFC: "../download/Ultralightweight_SpatialSpectral_Feature.pdf",
            landslide: "../download/Landslide.pdf",
            DESSN: "../download/DESSN.pdf",
            ASENet: "../download/ASENet.pdf",
            SDC_SSL: "../download/SDC-SSL.pdf",
            AFCF: "../download/AFCF.pdf",
            SGUNet: "../download/SGUNet.pdf",
            AMRR: "../download/AMRR.pdf",
            medicalsurvey: "../download/Medical-image-segmentation-survey.pdf",
            SFFCM: "../download/SFFCM.pdf",
            FRFCM: "../download/FRFCM.pdf",
            SE_MGMM: "../download/SE-MGMM.pdf",
            a_conditionally_invariant_mathematical_morphological: "../download/a conditionally invariant mathematical morphological.pdf",
            research_progress_on_image_segmentation_based_on_fuzzy_clustering: "../download/research progress on image segmentation based on fuzzy clustering.pdf",
            Grain_segmentation_of_ceramic_materials: "../download/Grain segmentation of ceramic materials.pdf",
            FRSC: "../download/FRSC.pdf",
        };
    },
        methods: {

            jumpToHome() {
                this.$router.push({
                    name: "home",
                });
            },
            jumpToTutor() {
                this.$router.push({
                    name: "tutor",
                });
            },
            jumpToTeam() {
                this.$router.push({
                    name: "team",
                });
            },
            jumpToPaper() {
                this.$router.push({
                    name: "paper",
                });
            },
            jumpToHonor() {
                this.$router.push({
                    name: "honor",
                });
            },
            jumpToDownload() {
                this.$router.push({
                    name: "download",
                });
            },
            jumpToInnovation() {
                this.$router.push({
                    name: "innovation",
                });
            },
            jumpToService() {
                this.$router.push({
                    name: "service",
                });
            },
            jumpToInfluenceContribution() {
                this.$router.push({
                    name: "influence_contribution",
                });
            },
        },
    };
</script>

<style scoped>
    .tutor-page {
        width: 100%;
        height: 100%;
        background-color: #fffef9;
        display: flex;
        flex-direction: column;
    }

    .top-menu {
        width: 100%;
    }

  .top {
      height: 12vh;
      width: 100%;
      background-image: url("../../assets/bg.jpg");
      color: white;
      font-size: 2.1vmax;
      font-weight: 500;
      line-height: 12vh;
      text-align: center;
      letter-spacing: 1vmax;
  }

  .menu {
      display: flex;
      flex-direction: row;
      height: 5vh;
      font-size: 1.1vmax;
      line-height: 5vh;
      padding-left: 3.1vmax;
      background-color: #dfe8ed;
  }

  .menu-detail {
    padding: 0 0.5vmax;
    cursor: pointer;
  }

  .blank {
    background-color: #dfe8ed;
    height: 3px;
    width: 100%;
  }


    .menu-detail:hover {
        background-color: #dfe8ed;
    }

    .page-content {
        width: 100%;
    }

    .paper-block {
        border: 1px solid #517b95;
        margin: 10px 100px;
    }

    .paper-block-title {
        background-color: #7494b1;
        color: #ffffff;
        font-size: 18px;
        height: 30px;
        line-height: 30px;
        padding-left: 20px;
        letter-spacing: 3px;
    }

    .paper-block-word {
        line-height: 28px;
        padding-left: 20px;
        font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
        font-size: 18px;
    }

    .paper-block-word-item {
        padding-bottom: 10px;
    }

    .icon-yuandianzhong {
        color: #8a9098;
    }
    .footer{
        height: 70px;
        background-color: 	#575D64;
        color: #ffffff;
        line-height: 70px;
        text-align: center;
        margin-top: 30px;
    }
</style>>